import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class DebitMembership extends BaseModel {
    @Expose() accountNumber = "";
    @Expose() accountType = "";
    @Expose() currency = "";
    @Expose() entity = "";
    @Expose() updateDate = "";
}
